module.exports = __webpack_public_path__ + "img/743b1628b74cf46982c6205eaf1f10b3.png";